export default __webpack_public_path__ + "38215cd.png";